<template>
  <div>
    <h1>{{ $store.getters.user.username }}</h1>
    <v-text-field
      v-if="modo=='principal'"
      label="Buscar"
      v-model="searchText"
      @keyup="agendarBuscar"
      @click:clear="clear"
      clearable
    ></v-text-field>

    <h2 v-if="errorMessage" class="red--text">{{errorMessage}}</h2>
    <div v-if="modo=='principal'">

      <v-btn class="ma-2" color="primary" small @click="miLista">MI LISTA</v-btn>
      <v-btn class="ma-2" color="primary" small @click="misEngregas">MIS ENTGREGAS</v-btn>
      <v-btn class="ma-2" color="primary" small @click="newSocio">A NO SOCIO</v-btn>
    </div>

    <div v-if="modo=='principal'">
      <v-progress-linear v-if="loading" indeterminate color="green"></v-progress-linear>
      <v-card max-width="650px">

        <v-card-text>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Cedula</th>
                  <th class="text-left">Nombres</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.codMemSq" @click="test(item)">
                  <td>{{ item.cedula }}</td>
                  <td>{{ item.nombres }}</td>
                  <td>
                    <v-icon v-if="item.fechaEntrega != null" class="green--text"
                      >check_circle</v-icon
                    >
                  </td>
                  <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </div>
    <v-card v-if="modo=='entregaSocio'" loading="true" max-width="650px" >
      <v-card-title> {{ socio.cedula }} {{ socio.nombres }} </v-card-title>

      <v-card-text>
        <!-- <h3>ENTRADO AL:</h3>
        <v-radio-group v-model="modo" :mandatory="true">
          <v-radio label="Socio" value="socio"></v-radio>
          <v-radio
            label="Otro (familiar, conocido, etc)"
            value="Otro"
          ></v-radio>
        </v-radio-group> -->

        <h3 v-if="socio.fechaEntrega != null">
          <v-icon class="green--text">check_circle</v-icon>
          Entregado el: {{ socio.fechaEntrega | formatDate }} - {{ socio.usuarioEntrega }}
        </h3>
        

        <v-textarea
          auto-grow
          rows="1"
          type="text"
          label="Observaciones"
          v-model="socio.observaciones"
        />

      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="socio = null; errorMessage = ''; modo = 'principal'">VOLVER</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          :loading="loading"
          @click="registrarEngrega"
          :disabled="socio.fechaEntrega != null"
          >REGISTRAR ENTREGA</v-btn
        >
      </v-card-actions>
    </v-card>


    <v-card v-if="modo == 'entregaNoSocio'" max-width="650px">
      <v-card-title>ENTREGA DE KIT A NO SOCIO</v-card-title>
      <v-card-text>
        <v-text-field type=text label="Cedula" v-model="socio.cedula" autofocus/>
        <v-text-field type=text label="Nombres" v-model="socio.nombres"/>
        <v-textarea
          auto-grow
          rows="1"
          type="text"
          label="Observaciones"
          v-model="socio.observaciones"
          hint="Ingrese la descripcion del motivo del cambio"
        />

      </v-card-text>
      <v-card-actions>
        <v-btn @click="noSocio = null; modo='principal'">CANCELAR</v-btn>
        <v-btn class="warning" @click="registrarEngrega" :loading="loading">REGISTRAR ENTREGA</v-btn>
      </v-card-actions>

    </v-card>

  </div>
</template>

<script>
// import numeral from "numeral";
import axios from "axios";
import moment from 'moment';

export default {
  mounted() {
    this.miLista()
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      searchText: "",
      items: [],
      socio: null,
      noSocio: null,
      modo: "principal",
      buscando: false,
      buscandoTimeout: false,
    };
  },
  methods: {
    test(item) {
      this.socio = item;
      this.modo = 'entregaSocio';
    },
    registrarEngrega() {
      // this.socio.entregado = true;
      // this.socio = null;
      this.errorMessage = '';

      this.loading = true;
      axios
        .post("/entrega-kit/registrar", this.socio)
        .then((res) => {
          console.log(res);
          this.errorMessage = '';
          this.socio.fechaEntrega = res.data.fechaEntrega;
          this.socio.observaciones = res.data.observaciones;
          this.socio.usuarioEntrega = res.data.usuarioEntrega;
          this.items = [this.socio];
          this.socio = null;
          this.modo = 'principal'
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error inesperado";
          }
          
        });
    },
    clear() {
      this.searchText = "";
      this.observacion = "";
      this.items = [];
    },
    agendarBuscar() {
      if (!this.searchText || this.searchText.length <= 3) return;

      clearTimeout(this.buscandoTimeout);
      this.buscandoTimeout = setTimeout(() => {
        this.buscar();
      }, 1500);

      // if (this.searchText) {

      //   this.itemsFiltrado = this.items.filter(i => {
      //     return i.nombres.toUpperCase().includes(this.searchText.toUpperCase()) || (i.cedula != null  && i.cedula.toUpperCase().includes(this.searchText.toUpperCase()))
      //   });

      // } else {
      //   this.itemsFiltrado = this.items;
      // }
    },
    buscar() {
      console.log("ahora hacemos la busqueda nueva");
      this.loading = true;

      axios
        .get("/entrega-kit?q=" + this.searchText)
        .then((res) => {
          this.items = res.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    miLista() {
      axios
        .get("/entrega-kit?q=:MILISTA")
        .then((res) => {
          this.items = res.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    misEngregas() {
      axios
        .get("/entrega-kit?q=:MISENTREGAS")
        .then((res) => {
          this.items = res.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    newSocio() {
      this.socio = { cedula: '', nombres: '', observaciones: '' };
      this.modo = 'entregaNoSocio';
    },

  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    },
  }
};
</script>